import { Component } from '@angular/core';
@Component({
    standalone: false,
    selector: 'cva-bottom-sheet',
    templateUrl: './bottom-sheet.component.html',
    styleUrl: './bottom-sheet.component.scss',
    
})
export class BottomSheetComponent {
  toggleState = false;

  toggleExpandCollapse() {
    const container = document.querySelector('.mat-bottom-sheet-container');
    if (container?.classList.contains('expanded')) {
      container.classList.remove('expanded');
    } else {
      container?.classList.add('expanded');
    }
  }

  updateHeight(){
    const questionsContainer = document.querySelector('.questions-card-content');
    if(this.toggleState){
      questionsContainer?.classList.add('questions-card-content-checked');
    }else{
      questionsContainer?.classList.remove('questions-card-content-checked');
    }
  }
}
